export enum ClassOptions {
    NURSERY = "Nursery",
    LKG = "LKG",
    UKG = "UKG",
    FIRST = "1st",
    SECOND = "2nd",
    THIRD = "3rd",
    FOURTH = "4th",
    FIFTH = "5th",
    SIXTH = "6th",
    SEVENTH = "7th",
    EIGHTH = "8th",
    NINTH = "9th",
    TENTH = "10th",
    ELEVENTH = "11th",
    TWELFTH = "12th"
}

export const CLASS_OPTIONS_ARRAY = Object.values(ClassOptions);

export function getClassRank(className: string): number {
    if (!className) return Number.MAX_SAFE_INTEGER;

    // Extract base class name (e.g. "10th A" -> "10th")
    const baseName = className.trim().split(/\s+|-/)[0];

    // Find index in CLASS_OPTIONS_ARRAY
    const rank = CLASS_OPTIONS_ARRAY.findIndex(cls => cls.toLowerCase() === baseName.toLowerCase());

    return rank !== -1 ? rank : Number.MAX_SAFE_INTEGER;
}

export interface SortableClassOption {
    name?: string;
    section?: string | null;
}

export function compareClassesByGradeAndSection(a: SortableClassOption, b: SortableClassOption): number {
    const rankDiff = getClassRank(a.name || "") - getClassRank(b.name || "");
    if (rankDiff !== 0) return rankDiff;

    const sectionDiff = String(a.section || "").localeCompare(String(b.section || ""), undefined, {
        numeric: true,
        sensitivity: "base",
    });
    if (sectionDiff !== 0) return sectionDiff;

    return String(a.name || "").localeCompare(String(b.name || ""), undefined, {
        numeric: true,
        sensitivity: "base",
    });
}
